import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCounterOffers extends Layout {
    labelWaterfallOfferCount: Label;
    sourceCarrierOffer: DataSource;
    sourceMovement: DataSource;
    tableOffers: Table;
}
